import { BarId, DiggerBadgeId, DiggerId } from "./enums"

export interface DiggerCard {
  id: DiggerId
  name: string
  bio?: string
  image?: string
  bars: {
    mile1?: BarId[]
    mile2?: BarId[]
    mile25?: BarId[]
    mile3?: BarId[]
    mile4?: BarId[]
    mile5?: BarId[]
    mile6?: BarId[]
    mile7?: BarId[]
    extra?: BarId[]
  }
  badges: DiggerBadgeId[]
}

export const diggers: DiggerCard[] = [
  {
    id: DiggerId.Kvertinsky,
    name: "Квертински",
    bio: "Я всё это придумал, и мне всё это пить...",
    image: "kvertinsky.jpg",
    bars: {
      mile1: [
        BarId.Samocvet,
        BarId.DvaDeda,
        BarId.Health,
        BarId.Irish,
        BarId.InnocentPeople,
        BarId.Pravda,
        BarId.NeBar,
      ],
      mile2: [
        BarId.Mon,
        BarId.Sova,
        BarId.Mango,
        BarId.Kaifooi,
        BarId.OurBar,
        BarId.Nravs,
        BarId.NewBar,
      ],
      mile25: [
        BarId.Spletni,
        BarId.InTouch,
        BarId.Izakaya,
        BarId.Kritik,
        BarId.Melody,
        BarId.SleepingDog,
        BarId.Mivino,
      ],
      mile3: [
        BarId.Television,
        BarId.Strelka,
        BarId.Collective,
        BarId.Gastrols,
        BarId.Baiks,
      ],
      mile4: [
        BarId.Fjord,
        BarId.Health,
        BarId.Fjord,
        BarId.Amigos,
        BarId.Stavnikov,
        BarId.Pils,
        BarId.Geograf,
        BarId.Spletni,
        BarId.Collective,
      ],
      mile5: [
        BarId.Health,
        BarId.Podpolie,
        BarId.Spletni,
        BarId.Pils,
        BarId.SleepingDog,
      ],
      mile6: [BarId.Health, BarId.Television, BarId.Samocvet],
      mile7: [
        BarId.Health,
        BarId.Samocvet,
        BarId.Collective,
        BarId.Fjord,
        BarId.Salut,
        BarId.Yankee,
        BarId.Opyt,
        BarId.Melody,
        BarId.SleepingDog,
        BarId.Pocherk,
      ],
      extra: [
        BarId.Killfish,
        BarId.Prorock,
        BarId.Nelson,
        BarId.Three,
        BarId.Americanka,
        BarId.Kam,
        BarId.PushInBar,
        //
        BarId.Bones50,
        BarId.Strelka,
        BarId.Sbors,
        BarId.Slova,
        BarId.Collective,
        BarId.Geograf,
        BarId.Sbors,
        BarId.Fjord,
        BarId.GrottSpot,
        BarId.ForeverYoung,
        BarId.BreakingBad,
        BarId.Yankee,
        BarId.Opyt,
        BarId.Bushes,
      ],
    },
    badges: [
      DiggerBadgeId.Father,
      DiggerBadgeId.Longliver,
      DiggerBadgeId.WhiteRussian,
    ],
  },
  {
    id: DiggerId.Sun,
    name: "☀️",
    bars: {
      extra: [
        BarId.Nelson,
        BarId.Health,
        BarId.ForeverYoung,
        BarId.BreakingBad,
      ],
    },
    badges: [],
  },
  {
    id: DiggerId.Kot,
    name: "Кот",
    bio: `
      Кочевник. Избранный. Аватар (по крайней мере по прическе).
      Каждый раз пью как в последний. Уровень выработки фермента, расщепляющего алкоголь, выше среднестатистического человека. 
      Питаю слабость к абсенту и огню.
      Сначала напою тебя до потери сознания, а потом позабочусь о твоем бездыханном теле.
      По легенде имею 9 жизней, по факту проверить невозможно, так как напоить практически нереально.
      Характер дружелюбный, внешность обманчивая.
      Мяу!
    `,
    image: "kot.jpg",
    bars: {
      mile1: [
        BarId.Samocvet,
        BarId.DvaDeda,
        BarId.Health,
        BarId.Irish,
        BarId.InnocentPeople,
        BarId.Pravda,
        BarId.NeBar,
      ],
      mile2: [],
      mile25: [
        BarId.Spletni,
        BarId.InTouch,
        BarId.Izakaya,
        BarId.Kritik,
        BarId.Melody,
        BarId.SleepingDog,
        BarId.Mivino,
      ],
      mile3: [BarId.Strelka, BarId.Collective, BarId.Gastrols],
      extra: [
        BarId.StayTrue,
        BarId.Lovecraft,
        BarId.RustyDed,
        BarId.Kotze,
        BarId.Mishka,
        BarId.Poison,
        BarId.Teremok,
        BarId.Dogma,
        BarId.Grott,
        BarId.NewBar,
        BarId.Nelson,
        BarId.Bones50,
        BarId.Mint,
      ],
    },
    badges: [
      DiggerBadgeId.Father,
      DiggerBadgeId.Firebender,
      DiggerBadgeId.Longliver,
    ],
  },
  {
    id: DiggerId.Kokos,
    name: "Кокосик",
    bars: {
      mile1: [
        BarId.Samocvet,
        BarId.DvaDeda,
        BarId.Health,
        BarId.Irish,
        BarId.InnocentPeople,
        BarId.Pravda,
        BarId.NeBar,
      ],
      mile2: [
        BarId.Mon,
        BarId.Sova,
        BarId.Mango,
        BarId.Kaifooi,
        BarId.OurBar,
        BarId.Nravs,
      ],
      mile25: [BarId.Spletni, BarId.InTouch, BarId.Izakaya, BarId.Kritik],
      mile3: [
        BarId.Television,
        BarId.Strelka,
        BarId.Collective,
        BarId.Gastrols,
        BarId.Baiks,
      ],
      mile4: [
        BarId.Fjord,
        BarId.Health,
        BarId.Fjord,
        BarId.Amigos,
        BarId.Stavnikov,
        BarId.Pils,
      ],
      mile5: [BarId.Health, BarId.Podpolie, BarId.Spletni, BarId.Pils],
      extra: [
        BarId.Nelson,
        BarId.Strelka,
        BarId.Sbors,
        BarId.Slova,
        BarId.Collective,
        BarId.NewBar,
        BarId.Grott,
        BarId.Lovecraft,
        BarId.Misantrope,
        BarId.Boroda,
        BarId.BioShmio,
      ],
    },
    badges: [DiggerBadgeId.Father, DiggerBadgeId.Longliver],
  },
  {
    id: DiggerId.Lex,
    name: "Лёха",
    bars: {
      mile1: [BarId.Irish, BarId.InnocentPeople, BarId.Pravda, BarId.NeBar],
      mile2: [BarId.Mango, BarId.Kaifooi, BarId.OurBar, BarId.Nravs],
      extra: [BarId.Television],
    },
    badges: [DiggerBadgeId.Longliver],
  },
  //
  {
    id: DiggerId.An,
    name: "Андрей",
    bars: {
      mile2: [
        BarId.Mon,
        BarId.Sova,
        BarId.Mango,
        BarId.Kaifooi,
        BarId.OurBar,
        BarId.Nravs,
        BarId.NewBar,
      ],
    },
    badges: [],
  },
  // {
  //   id: DiggerId.Jopa,
  //   name: "jopa_sjela_volka", // Ю
  //   image: "jopa_sjela_volka.jpg",
  //   bars: {
  //     mile2: [
  //       BarId.Mon,
  //       BarId.Sova,
  //       BarId.Mango,
  //       BarId.Kaifooi,
  //       BarId.OurBar,
  //       BarId.Nravs,
  //     ],
  //     mile25: [
  //       BarId.Izakaya,
  //       BarId.Kritik,
  //       BarId.Melody,
  //       BarId.SleepingDog,
  //       BarId.Mivino,
  //     ],
  //     mile3: [
  //       BarId.Television,
  //       BarId.Strelka,
  //       BarId.Collective,
  //       BarId.Gastrols,
  //       BarId.Baiks,
  //     ],
  //     extra: [
  //       BarId.Bones50,
  //       BarId.InTouch,
  //       BarId.PushInBar,
  //       BarId.Nelson,
  //       BarId.Samocvet,
  //       BarId.Sbors,
  //       BarId.Three,
  //       BarId.Americanka,
  //       BarId.Killfish,
  //       BarId.NewBar,
  //       BarId.DoubleGrill,
  //       BarId.Grott,
  //       BarId.Geograf,
  //       BarId.Yankee,
  //       BarId.Bukowski,
  //       BarId.Opyt,
  //       BarId.Melody,
  //       BarId.RosyJane,
  //       BarId.Fjord,
  //       BarId.RedCooper,
  //       BarId.UncleHoward,
  //       BarId.Air,
  //       BarId.BenHall,
  //       BarId.Mom,
  //     ],
  //   },
  //   badges: [DiggerBadgeId.Longliver, DiggerBadgeId.StairsSlayer],
  // },
  {
    id: DiggerId.Lada,
    name: "Lada X-RAY",
    bars: {
      mile2: [
        BarId.Sova,
        BarId.Mango,
        BarId.Kaifooi,
        BarId.OurBar,
        BarId.Nravs,
        BarId.NewBar,
      ],
      mile25: [
        BarId.Spletni,
        BarId.InTouch,
        BarId.Izakaya,
        BarId.Kritik,
        BarId.Melody,
        BarId.SleepingDog,
        BarId.Mivino,
      ],
      mile3: [
        BarId.Television,
        BarId.Strelka,
        BarId.Collective,
        BarId.Gastrols,
        BarId.Baiks,
      ],
      mile5: [
        BarId.Health,
        BarId.Podpolie,
        BarId.Spletni,
        BarId.Pils,
        BarId.SleepingDog,
      ],
      mile7: [
        BarId.Health,
        BarId.Samocvet,
        BarId.Collective,
        BarId.Fjord,
        BarId.Salut,
        BarId.Yankee,
        BarId.Opyt,
        BarId.Melody,
        BarId.SleepingDog,
        BarId.Pocherk,
      ],
      extra: [BarId.Nelson, BarId.Health, BarId.Bones50],
    },
    badges: [DiggerBadgeId.WhiteRussian, DiggerBadgeId.Longliver],
  },
  {
    id: DiggerId.Mihael,
    name: "Михаил Андреевич",
    bars: {
      mile2: [BarId.Sova, BarId.Mango, BarId.Kaifooi, BarId.OurBar],
      mile7: [BarId.SleepingDog, BarId.Pocherk],
      extra: [BarId.Nelson, BarId.NewBar],
    },
    badges: [],
  },
  {
    id: DiggerId.Eduard,
    name: "Эдуард",
    bars: {
      mile2: [BarId.OurBar, BarId.Nravs, BarId.NewBar],
    },
    badges: [DiggerBadgeId.Longliver],
  },
  // {
  //   id: DiggerId.Ge,
  //   name: "Г",
  //   bars: {
  //     mile1: [],
  //     mile2: [],
  //     extra: [],
  //   },
  //   badges: [],
  // },
  {
    id: DiggerId.Gleb,
    name: "Глеб",
    bars: {
      mile2: [BarId.OurBar, BarId.Nravs, BarId.NewBar],
    },
    badges: [],
  },
  {
    id: DiggerId.Evgenia,
    name: "Евгения",
    bars: {
      mile2: [
        BarId.Mango,
        BarId.Kaifooi,
        BarId.OurBar,
        BarId.Nravs,
        BarId.NewBar,
      ],
      mile3: [
        BarId.Television,
        BarId.Strelka,
        BarId.Collective,
        BarId.Gastrols,
        BarId.Baiks,
      ],
      extra: [BarId.Strelka, BarId.Sbors, BarId.Slova, BarId.Collective],
    },
    badges: [DiggerBadgeId.Longliver],
  },
  {
    id: DiggerId.Lena,
    name: "Лена",
    bars: {
      mile2: [BarId.OurBar, BarId.Nravs],
      mile3: [
        BarId.Television,
        BarId.Strelka,
        BarId.Collective,
        BarId.Gastrols,
        BarId.Baiks,
      ],
    },
    badges: [],
  },
  {
    id: DiggerId.Ilya,
    name: "Илья",
    bars: {
      mile2: [BarId.Sova, BarId.Mango, BarId.Kaifooi],
    },
    badges: [],
  },
  {
    id: DiggerId.Dima,
    name: "Дима",
    bars: {
      mile2: [BarId.OurBar],
    },
    badges: [],
  },
  {
    id: DiggerId.Sempai,
    name: "Семпай",
    bars: {
      extra: [BarId.Nelson, BarId.Slova, BarId.Collective, BarId.NewBar],
    },
    badges: [],
  },
  {
    id: DiggerId.Artem,
    name: "Артём",
    bars: {
      mile3: [
        BarId.Television,
        BarId.Strelka,
        BarId.Collective,
        BarId.Gastrols,
        BarId.Baiks,
      ],
      mile5: [BarId.Podpolie, BarId.Spletni, BarId.Pils, BarId.SleepingDog],
      extra: [BarId.NewBar, BarId.Sbors, BarId.Fjord],
    },
    badges: [DiggerBadgeId.Longliver],
  },
  {
    id: DiggerId.Daria,
    name: "Дарья",
    bars: {
      extra: [BarId.NewBar],
    },
    badges: [],
  },
  {
    id: DiggerId.Plur,
    name: "Саня",
    bars: {
      mile3: [],
      mile4: [
        BarId.Fjord,
        BarId.Amigos,
        BarId.Stavnikov,
        BarId.Pils,
        BarId.Geograf,
        BarId.Spletni,
        BarId.Collective,
      ],
      mile5: [BarId.Podpolie, BarId.Spletni, BarId.Pils, BarId.SleepingDog],
      mile6: [BarId.Health, BarId.Samocvet],
    },
    badges: [],
  },
  {
    id: DiggerId.Sasha,
    name: "Саша",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [BarId.Podpolie, BarId.Spletni, BarId.Pils],
    },
    badges: [],
  },
  {
    id: DiggerId.Vadim,
    name: "Вадим",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [BarId.Podpolie, BarId.Spletni, BarId.Pils],
      mile7: [BarId.Pocherk],
    },
    badges: [],
  },
  {
    id: DiggerId.Maria,
    name: "Мария",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [BarId.Podpolie, BarId.Spletni, BarId.Pils, BarId.SleepingDog],
    },
    badges: [],
  },
  {
    id: DiggerId.Ivan,
    name: "Иван",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [BarId.Health, BarId.Podpolie, BarId.Spletni, BarId.Pils],
    },
    badges: [],
  },
  {
    id: DiggerId.Alexa,
    name: "Alexa",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [BarId.Podpolie, BarId.Spletni, BarId.Pils, BarId.SleepingDog],
    },
    badges: [],
  },
  {
    id: DiggerId.Anatoly,
    name: "Anatoly",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [BarId.Health, BarId.Podpolie],
    },
    badges: [],
  },
  {
    id: DiggerId.Mashulkins,
    name: "Mashulkins",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [],
      mile6: [BarId.Samocvet, BarId.Health],
    },
    badges: [],
  },
  {
    id: DiggerId.Sevara,
    name: "Sevara",
    bars: {
      mile3: [],
      mile4: [],
      mile5: [],
      mile6: [BarId.Health, BarId.Television, BarId.Samocvet],
    },
    badges: [],
  },
]
